import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

const LocationTransfer = () => {
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Konum Transferi
      </Typography>
      <Paper sx={{ p: 2 }}>
        <Typography>Konum transferi burada görüntülenecek</Typography>
      </Paper>
    </Box>
  );
};

export default LocationTransfer;
